export const getRoutesRespAviation = () => {
  return {
    routes: [
      {
        origin: "JFK",
        destination: "LHR",
      },
      {
        origin: "LHR",
        destination: "JFK",
      },
      {
        origin: "MEX",
        destination: "CUN",
      },
      {
        origin: "CUN",
        destination: "MEX",
      },
      {
        origin: "LHR",
        destination: "LAX",
      },
      {
        origin: "LAX",
        destination: "LHR",
      },
      {
        origin: "TIJ",
        destination: "GDL",
      },
      {
        origin: "GDL",
        destination: "TIJ",
      },
      {
        origin: "TIJ",
        destination: "MEX",
      },
      {
        origin: "MEX",
        destination: "GDL",
      },
      {
        origin: "GDL",
        destination: "MEX",
      },
      {
        origin: "MEX",
        destination: "TIJ",
      },
      {
        origin: "LHR",
        destination: "DEL",
      },
      {
        origin: "DEL",
        destination: "LHR",
      },
      {
        origin: "LHR",
        destination: "SFO",
      },
      {
        origin: "SFO",
        destination: "LHR",
      },
      {
        origin: "JNB",
        destination: "LHR",
      },
      {
        origin: "LHR",
        destination: "MIA",
      },
      {
        origin: "GDL",
        destination: "CUN",
      },
      {
        origin: "CUN",
        destination: "GDL",
      },
      {
        origin: "MIA",
        destination: "LHR",
      },
      {
        origin: "LHR",
        destination: "JNB",
      },
      {
        origin: "LOS",
        destination: "LHR",
      },
      {
        origin: "TIJ",
        destination: "CUL",
      },
      {
        origin: "LHR",
        destination: "LOS",
      },
    ],
  };
};
